var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackSuggestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1875 15.4131H9.8125",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53365 10.8424C2.86399 10.3217 2.32162 9.65542 1.94763 8.89404C1.57364 8.13266 1.37784 7.29614 1.37506 6.44787C1.361 3.39631 3.8149 0.858026 6.86647 0.787713C8.04748 0.759717 9.20733 1.10426 10.1815 1.77249C11.1557 2.44071 11.8948 3.39869 12.294 4.51056C12.6931 5.62243 12.7321 6.83175 12.4053 7.96701C12.0786 9.10226 11.4027 10.1058 10.4735 10.8354C10.2682 10.994 10.102 11.1975 9.98743 11.4303C9.87288 11.663 9.81306 11.9189 9.81256 12.1783V12.6002C9.81256 12.7494 9.7533 12.8925 9.64781 12.998C9.54232 13.1035 9.39924 13.1627 9.25006 13.1627H4.75006C4.60088 13.1627 4.4578 13.1035 4.35231 12.998C4.24682 12.8925 4.18756 12.7494 4.18756 12.6002V12.1783C4.1858 11.9209 4.12611 11.6671 4.01291 11.4358C3.89971 11.2046 3.73591 11.0017 3.53365 10.8424V10.8424Z",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56934 3.09473C8.25683 3.21127 8.89121 3.53833 9.38491 4.03077C9.87861 4.52321 10.2073 5.15675 10.3256 5.84395",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSuggestion);
export default __webpack_public_path__ + "static/media/feedback-suggestion.d716a3f863ce7186b91861684321d1dc.svg";
export { ForwardRef as ReactComponent };